import { Numeric7BoxMultipleOutlineIcon } from './Numeric7BoxMultipleOutlineIcon';

/**
 * author: Google
 * id CF43DB99-4419-491B-A5E3-2486A36F24DB
 * name numeric-7-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-7-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericSevenBoxMultipleOutlineIcon = Numeric7BoxMultipleOutlineIcon;
export default NumericSevenBoxMultipleOutlineIcon